var map = {
	"./images/home_case_logoWall.webp": "9FFE",
	"./images/home_case_logoWall_h5.webp": "XKeX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lpCX";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.webp$
// module id = lpCX
// module chunks = 34